import type { AskResponse } from '../../types/lobbyDay'

export const RESPONSE_OPTIONS: { value: AskResponse; label: string; color: string }[] = [
  { value: 'NotRecorded', label: '—', color: 'gray' },
  { value: 'Yes', label: 'Yes', color: 'green' },
  { value: 'No', label: 'No', color: 'red' },
  { value: 'Maybe', label: 'Maybe', color: 'yellow' },
]

export function responseColor(r: AskResponse): string {
  return RESPONSE_OPTIONS.find((o) => o.value === r)?.color ?? 'gray'
}
